import styled from 'styled-components/macro';
import {CSS_MOBILE_BREAKPOINT,CSS_PADDING} from '../constants';
import Price from './RecapPrice';
import Arguments from './RecapArguments';


const RecapStyled = styled.div`
	padding: ${CSS_PADDING} 0 ${CSS_PADDING} ${CSS_PADDING};
	display: flex;
	.arguments {
		margin-left: ${CSS_PADDING};
		flex-grow: 1;
	}
	@media ${CSS_MOBILE_BREAKPOINT}{
		flex-direction: column;
		padding-left: 0;
		.arguments {
			margin-top: ${CSS_PADDING};
			margin-left:0;
		}
	}
`;


function Recap(props) {
	return (
		<RecapStyled>
			<Price {...props} />
			<Arguments {...props} className="arguments" />
		</RecapStyled>
	);
}

export default Recap;
